<script>
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import PageTitle from "$lib/components/Page/PageTitle.svelte";
  import Eyebrow from "$lib/components/Eyebrow.svelte";
  import SocialBar from "$lib/islands/Components/SocialBar.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import Island from "$lib/components/Island.svelte";

  export let title;
  export let featuredImage = null;
  export let eyebrow = {};
  export let byline = null;
  export let parentInfo;
  export let showSocialBar = true;

  let socialBarPaddingClass = "pb-48 lg:mb-104";
  let pageTitlePaddingClass = showSocialBar ? "lg:pb-48 pb-24" : "lg:pb-72 pb-48";
  let backgroundColorClass = "bg-neutral-100";
  if (featuredImage) {
    socialBarPaddingClass = "pb-24 lg:pb-48";
    pageTitlePaddingClass = "pb-24 lg:pb-48";
  }

  // This behavior can be overridden by specifying a breadcrumb
  if (!eyebrow.content && parentInfo) {
    eyebrow.content = parentInfo?.headline;
    eyebrow.link = parentInfo?.relativeUrl;
  }
</script>

<div class="w-full hero" test-id="hero">
  <Bleed fullWidth fullWidthClasses={backgroundColorClass} contentClasses="px-24 lg:px-72">
    <div class={`pt-48 lg:pt-72 flex flex-col ${backgroundColorClass}`}>
      <PageTitle class="lg:max-w-screen-lg lg:mx-auto order-2 {pageTitlePaddingClass}" {title} />

      {#if eyebrow.content}
        <Eyebrow class="lg:pb-48 pb-24 lg:max-w-screen-lg lg:mx-auto order-1" {...eyebrow} />
      {/if}

      {#if byline}
        <div class="lg:pb-24 pb-8 text-center lg:max-w-screen-lg lg:mx-auto order-3">
          <!-- Byline -->
          {#if byline.author}
            <span class="font-bold">{byline.author.name},</span>
            <span>{byline.author.organization}</span>
          {/if}
          <span class="font-bold">{byline.publishDate}</span>
        </div>
      {/if}
      {#if showSocialBar}
        <Island
          id="hero-social-bar"
          islandProps={{ class: `order-4 ${socialBarPaddingClass}` }}
          component={SocialBar}
          name="SocialBar"
          class="lg:max-w-screen-lg lg:mx-auto"
        />
      {/if}
    </div>
  </Bleed>
  {#if featuredImage}
    <Bleed fullWidth fullWidthClasses="bg-hero lg:bg-hero-lg" contentClasses="px-24 lg:px-72">
      <div class="">
        <ImageComponent
          containerClass="w-full place-items-center"
          elementClass="object-cover w-full rounded-5 lg:max-w-screen-lg lg:m-auto"
          data={featuredImage}
          displayCaption={false}
          containerized={true}
          lg={"1250px"}
          responsive
        />
      </div>
    </Bleed>
  {/if}
</div>
